import { deserialise } from 'kitsu-core'

export default ({ data }) => {
  return deserialise(data)
}
